import { Customer, CustomerSetting, Route, Site } from '../../entities';

/**
 * A customer an order can be placed for, as returned by the customer controller
 */
export interface CustomerOrderOptionsDto {
  id: number;
  name: string;
  customerSetting: {
    id: number;
    dueDaysToPlaceOrders: number;
    dueTimeToPlaceOrders: string;
    dueDaysToCancelOrders: number;
    dueTimeToCancelOrders: string;
    prepackMeals: boolean;
  } | null;
  sites: Array<{
    id: number;
    name: string;
    county: string;
    siteNumber: string;
    custSiteNumber: string;
    displaySiteNumber: string;
    isActive: boolean;
    routes: Array<{ id: number; name: string }>;
  }>;
}

/**
 * Maps a customer option to a Customer shaped like the ones loaded through the JSON:API, so that it can be passed
 * to the order form and the components which still use the JSON:API
 */
// TODO: Update this funtion to use one Customer structure after migrating from JSON:API
export const toCustomer = (item: CustomerOrderOptionsDto): Customer =>
  Object.assign(new Customer(), {
    id: String(item.id),
    name: item.name,
    customerSetting: Object.assign(new CustomerSetting(), {
      ...(item.customerSetting ?? {}),
      id: item.customerSetting ? String(item.customerSetting.id) : undefined,
    }),
    sites: item.sites.map((site) =>
      Object.assign(new Site(), {
        id: String(site.id),
        name: site.name,
        county: site.county,
        siteNumber: site.siteNumber,
        custSiteNumber: site.custSiteNumber,
        displaySiteNumber: site.displaySiteNumber,
        isActive: site.isActive,
        routes: site.routes.map((route) =>
          Object.assign(new Route(), { id: String(route.id), name: route.name })
        ),
      })
    ),
  });
